import { render, staticRenderFns } from "./SelectTemplateIdWidget.vue?vue&type=template&id=17837140&"
import script from "./SelectTemplateIdWidget.vue?vue&type=script&lang=js&"
export * from "./SelectTemplateIdWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports